import React, { PureComponent } from 'react';
import { BASE_URL } from '../config';

export default class Footer extends PureComponent {
  render() {
    return (
      <footer>
        <style>{`
        footer {
          padding: 40px 0;
          color: #999;
        }
        `}</style>
        <a href="http://www.atlassian.com/" target="_blank" rel="noopener noreferrer">Atlassian</a>
        &nbsp;
        &bull;
        &nbsp;
        <a href={`${BASE_URL}/api/full.json`}>API data</a>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx